import { createAction, props } from '@ngrx/store';
import { GBPModel } from '../../models/gbp.model';

export const enum GBPActionTypes {
  loadGBPAction = '[GBP] Load GBP',
  loadGBPSuccessAction = '[GBP] Load GBP Success',
  loadGBPErrorAction = '[GBP] Load GBP Error',
}

export const loadGBPBegin = createAction(
  GBPActionTypes.loadGBPAction
);

export const loadGBPSuccess = createAction(
  GBPActionTypes.loadGBPSuccessAction,
  props<{ payload: GBPModel }>()
);

export const loadGBPError = createAction(
  GBPActionTypes.loadGBPErrorAction,
  props<{ payload: any }>()
);

